import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Erro inesperado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export function brl(v) {
  return (v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function maskCPF(v = "") {
  const d = v.replace(/\D/g, "").slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function monthLabel(m) {
  if (!m) return "-";
  const [y, mm] = m.split("-").map(Number);
  return new Date(y, mm - 1, 1).toLocaleDateString("pt-BR", { month: "short", year: "numeric" });
}

export function dateBR(iso) {
  if (!iso) return "-";
  const d = new Date(iso.length === 10 ? `${iso}T12:00:00` : iso);
  return isNaN(d) ? iso : d.toLocaleDateString("pt-BR");
}

export async function downloadFile(path, filename, params) {
  try {
    const res = await api.get(path, { params, responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  } catch (err) {
    alert("Falha ao exportar arquivo.");
  }
}

export function whatsappReminderLink(name, phone, dueDate, fee = 30) {
  let d = (phone || "").replace(/\D/g, "");
  if (d.length === 10 || d.length === 11) d = `55${d}`;
  const first = (name || "").split(" ")[0];
  const msg =
    `Olá, ${first}! Aqui é do Ressignificar Benefícios. ` +
    `Lembrete: sua mensalidade de ${brl(fee)} vence em ${dateBR(dueDate)}. ` +
    `Você pode pagar por Pix (PicPay, chave +5531975548913) e informar o pagamento na sua Área do Associado. Obrigado!`;
  return `https://wa.me/${d}?text=${encodeURIComponent(msg)}`;
}

export function whatsappChargeLink(name, phone, dueDate, days = 0, fee = 30) {
  let d = (phone || "").replace(/\D/g, "");
  if (d.length === 10 || d.length === 11) d = `55${d}`;
  const first = (name || "").split(" ")[0];
  const msg =
    `Olá, ${first}! Aqui é do Ressignificar Benefícios. ` +
    `Sua mensalidade de ${brl(fee)} venceu em ${dateBR(dueDate)}${days ? ` (há ${days} dia(s))` : ""}. ` +
    `Você pode pagar por Pix (PicPay, chave +5531975548913) e informar o pagamento na sua Área do Associado. Se já pagou, desconsidere esta mensagem. Obrigado!`;
  return `https://wa.me/${d}?text=${encodeURIComponent(msg)}`;
}

export function maskPhone(v = "") {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10)
    return d.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3").trim();
  return d.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3").trim();
}
